export const environment = {
  production: false,
  showTickets: true,
  server: 'https://api-gateway.dev.dokuma.co.zw/deeds/',
  farms: 'https://land-tenure-api.dev.dokuma.co.zw/farms/',
  applicationUrl: 'http://localhost:4200/',
  googleClientId: '98860499288-ui7glnqbbls2tqmcenmgh7ndeb7s2rcm.apps.googleusercontent.com',
  googleRedirectUri: 'https://ebanking.testing.dokuma.co.zw/',
  iveriReturnUrl: 'https://api-gateway.dev.dokuma.co.zw/deeds/public/payment/authenticate',
  zimswitchGateway: 'https://eu-prod.oppwa.com/v1/',
  paymentRedirectUrl: 'https://payment.testing.dokuma.digital/status/',
  econveyancerUrl: 'https://econveyancer.dev.dokuma.co.zw/auth/login'
};
